import { render, staticRenderFns } from "./addProduct.vue?vue&type=template&id=1425b31a&scoped=true"
import script from "./addProduct.vue?vue&type=script&lang=js"
export * from "./addProduct.vue?vue&type=script&lang=js"
import style0 from "./addProduct.vue?vue&type=style&index=0&id=1425b31a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1425b31a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1425b31a')) {
      api.createRecord('1425b31a', component.options)
    } else {
      api.reload('1425b31a', component.options)
    }
    module.hot.accept("./addProduct.vue?vue&type=template&id=1425b31a&scoped=true", function () {
      api.rerender('1425b31a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/publishProduct/addProduct.vue"
export default component.exports